var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChainWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1026 7.22943C38.3902 4.99758 41.6092 4.99758 42.8968 7.22942L76.2132 64.9783C77.5008 67.2102 75.8913 70 73.3161 70H6.68326C4.10808 70 2.49859 67.2102 3.78618 64.9783L37.1026 7.22943Z",
    fill: "#FA693C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0001 25.5555C42.673 25.5555 44.2823 27.8189 43.9507 30.3395L42.239 45.3702C42.1102 46.3489 41.2348 47.0833 40.197 47.0833H39.8032C38.7654 47.0833 37.89 46.3489 37.7612 45.3702L36.0495 30.3395C35.718 27.8189 37.3272 25.5555 40.0001 25.5555Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 51.3889C42.4547 51.3889 44.4446 53.3165 44.4446 55.6944C44.4446 58.0723 42.4547 60 40.0001 60C37.5455 60 35.5557 58.0723 35.5557 55.6944C35.5557 53.3165 37.5455 51.3889 40.0001 51.3889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainWarning);
export default __webpack_public_path__ + "static/media/chainWarning.8e466b4a877916d931086c4ede48ba84.svg";
export { ForwardRef as ReactComponent };